<div class="channel-not-found-container" *ngIf="showChannelErrorPage">
  <img src="assets/mascot/Mascot_sorry-Grey@2x.webp" alt="odaring mascot" />
  <h1 class="heading-8">{{'channel.not.found.title' | translate}}</h1>
  <button type="button" class="btn-refresh" (click)="navigateHome()">{{'button.back.home' | translate}}</button>
</div>
